import React, { useEffect, useState } from "react";
import { Grid, Typography, Divider, Box } from "@mui/material";

import axiosClient from "../axiosClient";
import { useStateContext } from "../context/ContextProvider";

const ZlistReport = ({ fromDate, toDate }) => {
  const { store } = useStateContext();

  const [data, setData] = useState();

  useEffect(() => {
    const correctStoreName = JSON.parse(store).name.replace(/[^a-zA-Z]/g,"");
    const databaseStoreName = `DB301_${JSON.parse(store).id}_${correctStoreName}`;

    const payload = {
      shopName: databaseStoreName,
      from: fromDate,
      to: toDate,
    };
    axiosClient
      .post("reports/sales/zlist", payload)
      .then((response) => setData(response.data.data))
      .catch((err) => console.log(err));
  }, [store, fromDate, toDate]);

  const formatDate = (dateString) => {
    const parts = dateString.split("-");
    if (parts.length === 3) {
      const [year, month, day] = parts;
      return `${day}/${month}/${year}`;
    } else {
      return "Invalid Date";
    }
  };

  function convertSqlDateTimeToDdMmYyyy(dateTimeString) {
    const [datePart, timePart] = dateTimeString.split("T");
    const [year, month, day] = datePart.split("-");

    return `${day}/${month}/${year}`;
  }

  function formatTimeFromSqlDateTime(dateTimeString) {
    const dateTime = new Date(dateTimeString);
    const hours = dateTime.getHours().toString().padStart(2, "0");
    const minutes = dateTime.getMinutes().toString().padStart(2, "0");
    const seconds = dateTime.getSeconds().toString().padStart(2, "0");
    return `${hours}:${minutes}:${seconds}`;
  }

  function sumAttributeIf(
    array,
    conditionAttribute,
    conditionValue,
    sumAttribute
  ) {
    return array.reduce((accumulator, currentValue) => {
      if (currentValue[conditionAttribute] === conditionValue) {
        return accumulator + currentValue[sumAttribute];
      } else {
        return accumulator;
      }
    }, 0);
  }

  function sumAttribute(array, attribute) {
    const attributeValues = array.map((obj) => obj[attribute]);
    const sum = attributeValues.reduce(
      (acc, currentValue) => acc + currentValue,
      0
    );

    return parseFloat(sum).toFixed(2);
  }

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography variant="inherit">Z Invoices</Typography>
        <Typography variant="caption">{` ${formatDate(fromDate)} - ${formatDate(
          toDate
        )}`}</Typography>
        <Divider />
      </Grid>
      <Grid item container xs={12}>
        <Grid item xs={1}>
          <Typography variant="body1" align="center">
            Z Number
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="body1" align="center">
            Invoice id
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="body1" align="center">
            Sunbet
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body1" align="center">
            Date
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body1" align="center">
            Time
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Typography variant="body1" align="center">
            Payment method
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body1" align="center">
            User
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body1" align="center">
            Total amount
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <Divider />
          </Box>
        </Grid>
      </Grid>
      {data.map((z, index) => {
        const nextValue =
          index + 1 < data.length ? data[index + 1].z_number : 0;

        const previousValue = index > 0 ? data[index - 1].z_number : 0;

        return (
          <Grid item container xs={12} key={index + 1}>
            <Grid item xs={1}>
              {previousValue !== z.z_number ? (
                <Typography variant="body2" align="center">
                  {z.z_number}
                </Typography>
              ) : null}
            </Grid>
            <Grid item xs={1}>
              <Typography variant="body2" align="center">
                {z.id}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="body2" align="center">
                {z.sbed? z.sbed : 'N/A'}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" align="center">
                {convertSqlDateTimeToDdMmYyyy(z.createdAt)}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" align="center">
                {formatTimeFromSqlDateTime(z.createdAt)}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <Typography variant="body2" align="center">
                {z.name === "Cash"
                  ? "CA"
                  : z.name === "Credit Card"
                  ? "CC"
                  : z.name === "Manual credit card"
                  ? "MCC"
                  : z.name === "Online payment"
                  ? "OP"
                  : "O"}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" align="center">
                {z.role}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Typography variant="body2" align="center">
                {parseFloat(z.total_gross_value).toFixed(2)}
              </Typography>
              {nextValue !== z.z_number ? (
                <Grid>
                  <Box mt={1} mb={1}>
                    <Divider />
                  </Box>
                  <Typography variant="body2" align="center">
                    {sumAttributeIf(
                      data,
                      "z_number",
                      z.z_number,
                      "total_gross_value"
                    ).toFixed(2)}
                  </Typography>
                </Grid>
              ) : null}
            </Grid>
            {nextValue !== z.z_number ? (
              <Grid item xs={12}>
                <Box mt={1} mb={1}>
                  <Divider />
                </Box>
              </Grid>
            ) : null}
          </Grid>
        );
      })}
      <Grid item container xs={12}>
        <Grid item xs={10}>
          <Typography variant="body1" align="center">
            Grand Totals:
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="body2" align="center">
            {sumAttribute(data, "total_gross_value")}
          </Typography>
        </Grid>
      </Grid>
      <Grid item xs={12}>
          <Box mt={1} mb={1}>
            <Divider />
          </Box>
        </Grid>
    </Grid>
  );
};

export default ZlistReport;
